import React from 'react'
import { products } from '../data/products'
import { type PricingProduct } from '../types/pricing.types';
import ProductBox from './ProductBox';
import HostSelection from './HostSelection';
import { type ProductFamily, type WebProduct } from '../../common/types/webshop.types';

import { fetchProductFamily } from '../../common/js/webshop-product-utility'
import { fetchProduct, fetchProductSettings } from '../js/pricing-utility';
import TypeSelection from './TypeSelection';
import QuantitySelect from '../../common/components/QuantitySelect';
import Button from '../../common/components/Button';
import { addToCart } from '../../common/js/cart-utility';
import CurrencySelect from '../../common/components/CurrencySelect';
import { fetchDefaultCurrency } from '../../common/js/currency-utility';
import { useTranslation } from 'react-i18next'

type Props = {defaultProduct: string}

export default function Pricing({defaultProduct}: Props) {
    const [family, setFamily] = React.useState<ProductFamily>();
    const [selectedProductSettings, setselectedProductSettings] = React.useState(products[0]);
    const [selectedHost, setSelectedHost] = React.useState('');
    const [selectedType, setSelectedType] = React.useState('New Annual Subscription');
    const [selectedFamily, setSelectedFamily] = React.useState('');
    const [quantity, setQuantity] = React.useState(1);
    const [currencyIso, setCurrencyIso] = React.useState('USD');

    const [processing, setProcessing] = React.useState(false);
    
    const {t} = useTranslation(['pricing-tool', 'common']);

    React.useEffect(() => {
        const doInit = async () => {
            const defaultCurrency = await fetchDefaultCurrency();
            setCurrencyIso(defaultCurrency);
        }
        doInit();
    }, [])

    React.useEffect(() => {
        const fetchFamily = async () => {
            if (!selectedFamily){
                return;
            }
            let famName = selectedFamily;
            if (famName.toLowerCase() == 'particle illusion pro'){
                famName = 'particle illusion';
            }
            const fam = await fetchProductFamily(famName);
            const matchingProd = fetchProductSettings(selectedFamily);
            setFamily(fam);
            setSelectedHost(matchingProd.hosts[0].name);
            setSelectedType('New Annual Subscription');
            setselectedProductSettings(matchingProd)
            
            return fam;
        }

        fetchFamily();
    }, [selectedFamily])

    React.useEffect(() => {
        setSelectedFamily(defaultProduct);
    }, [defaultProduct]);

    const handleHostChange = (host: string) => {
        setSelectedHost(host);
    }

    const handleTypeChange = (type: string) => {
        setSelectedType(type);
    }

    const handleProductChange = (familyName: string) => {
        setSelectedFamily(familyName);
    }

    const handleQuantityChange = (quantityNew: number) => {
        setQuantity(quantityNew);
    }

    const handleCurrencyChange = (newIso: string) => {
        setCurrencyIso(newIso);
    }

    const handleAddToCart = async () => {
        setProcessing(true);
        const prod = fetchProduct(family, selectedHost, selectedType);
        await addToCart(prod.sku, quantity, null, null, 'web', currencyIso);
        showCart();
        setProcessing(false);
    }

    let alternateProductName = getAltProduct(defaultProduct);

    let prodBoxes: React.JSX.Element[] = [<></>, <></>];
    const fullSizedBox = defaultProduct == 'boris fx suite' || defaultProduct == 'sequoia';
    products.forEach((p : PricingProduct) => {
        const titleLower = p.title.toLowerCase();
        if (alternateProductName == titleLower || defaultProduct == titleLower)
        {    
            const isAlt = alternateProductName == titleLower;
            const index =  isAlt ? 1 : 0;
            const selected = selectedProductSettings.slug == p.slug;
            prodBoxes[index] = (
                <ProductBox product={p} selected={selected} fullSizedBox={fullSizedBox} onClick={handleProductChange} isAlt={isAlt} />
            )
        }
    })

    
    
    return (
        <div>
            <HostSelection product={selectedProductSettings} selected={selectedHost} onChange={handleHostChange} />
            <div className='product-type-row'>
                <div className='product-boxes'>
                    {prodBoxes}
                </div>
                <div className='type-add-column'>
                    <TypeSelection currencyIso={currencyIso} family={family} host={selectedHost} selected={selectedType} onChange={handleTypeChange} />
                    <div className='add-to-cart'>
                        <div className='quantity-select-container'>
                            <span>{t('purchase.quantity', {ns: 'common'})}: </span>
                            <QuantitySelect onChange={handleQuantityChange} value={quantity} />
                            <CurrencySelect selectedIso={currencyIso} onChange={handleCurrencyChange} />
                        </div>
                        <div className='add-to-cart-button-container'>
                            <Button className='btn-new btn-new-dynamic add-to-cart-button' 
                                    label={t('actions.addToCart', {ns: 'common'})} 
                                    processingLabel="Please Wait. . ."
                                    processing={processing}
                                    onClick={handleAddToCart} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const getAltProduct = (defaultProduct: string): string => {
    switch(defaultProduct.toLowerCase()){
        case 'boris fx suite':
            return null;
        case 'particle illusion': case 'particle illusion pro':
            return 'continuum';
        case 'samplitude':
            return 'samplitude suite';
        case 'music studio':
            return 'samplitude';
        case 'sequoia':
            return '';
        default:
            return 'boris fx suite';
    }
}